// Supported languages list:
// https://cloud.google.com/translate/docs/languages
// Country code list:
// https://www.countryflags.io/
export const languagesWithoutEnglish = [
  { key: 'gu', value: 'gu', languageCode: 'guj', flag: 'in', text: 'Gujarati' },
  { key: 'am', value: 'am', flag: 'am', text: 'Amharic' },
  { key: 'ar', value: 'ar', flag: 'ps', text: 'Arabic' },
  { key: 'zh', value: 'zh', flag: 'cn', text: 'Chinese (Simplified)' },
  { key: 'zh-TW', value: 'zh-TW', flag: 'cn', text: 'Chinese (Traditional)' },
  { key: 'cs', value: 'cs', flag: 'cz', text: 'Czech' },
  { key: 'nl', value: 'nl', flag: 'nl', text: 'Dutch' },
  { key: 'tl', value: 'tl', flag: 'ph', text: 'Filipino (Tagalog)' },
  { key: 'fr', value: 'fr', flag: 'fr', text: 'French' },
  { key: 'de', value: 'de', flag: 'de', text: 'German' },
  { key: 'el', value: 'el', flag: 'gr', text: 'Greek' },
  { key: 'iw', value: 'iw', flag: 'il', text: 'Hebrew' },
  { key: 'hi', value: 'hi', flag: 'in', text: 'Hindi' },
  { key: 'hu', value: 'hu', flag: 'hu', text: 'Hungarian' },
  { key: 'id', value: 'id', flag: 'id', text: 'Indonesian' },
  { key: 'it', value: 'it', flag: 'it', text: 'Italian' },
  { key: 'ja', value: 'ja', flag: 'jp', text: 'Japanese' },
  { key: 'ms', value: 'ms', flag: 'my', text: 'Malay' },
  { key: 'my', value: 'my', flag: 'mm', text: 'Myanmar (Burmese)' },
  { key: 'ko', value: 'ko', flag: 'kr', text: 'Korean' },
  { key: 'pl', value: 'pl', flag: 'pl', text: 'Polish' },
  { key: 'pt', value: 'pt', flag: 'br', text: 'Portuguese' },
  { key: 'ro', value: 'ro', flag: 'ro', text: 'Romanian' },
  { key: 'ru', value: 'ru', flag: 'ru', text: 'Russian' },
  { key: 'es', value: 'es', flag: 'es', text: 'Spanish' },
  { key: 'ta', value: 'ta', flag: 'lk', text: 'Tamil' },
  { key: 'th', value: 'th', flag: 'th', text: 'Thai' },
  { key: 'tr', value: 'tr', flag: 'tr', text: 'Turkish' },
  { key: 'vi', value: 'vi', flag: 'vn', text: 'Vietnamese' },
  { key: 'sv', value: 'sv', flag: 'se', text: 'Swedish' },
];

export const languagesWithEnglish = [
  { key: 'en', value: 'en', flag: 'us', text: 'English' },
  ...languagesWithoutEnglish,
].sort((a, b) => {
  if (a.text < b.text) {
    return -1;
  }
  if (a.text > b.text) {
    return 1;
  }
  return 0;
});
